// extracted by mini-css-extract-plugin
export var wrapper = "community-section-module--wrapper--lETG3";
export var header = "community-section-module--header--T2iHP";
export var actionBtn = "community-section-module--action-btn--PZ7Cd";
export var circuitRow = "community-section-module--circuit-row--+o1za";
export var circuitCard = "community-section-module--circuit-card--AK5PN";
export var row = "community-section-module--row--es03O";
export var circuitCol = "community-section-module--circuit-col--9zVYp";